<ng-template hsPanelHost></ng-template>
